export default "__VITE_ASSET__qTAyR4DF__"